import React, { Component } from 'react';

import { RelatedEntityGrid as EntityGrid } from 'hay-core-react';
import { ModelTextArea } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelCalendar } from 'hay-core-react';
import TarefaAgendadaLog                from '../../../models/TarefaAgendadaLog';
import TarefaAgendada                    from '../../../models/TarefaAgendada';
import TarefaAgendadaLogStatusEnum      from '../../../enums/TarefaAgendadaLogStatusEnum';
import TarefaAgendadaLogTipoExecucaoEnum from '../../../enums/TarefaAgendadaLogTipoExecucaoEnum';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    id: { exibir: 'main.id', tipo: 'numeric', largura: '5rem', fixar: true },
    tarefaagendada: {
        exibir:       'main.tarefaagendadalog.tarefaagendada',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'nome',
        entidade:     'tarefaagendada.entidade',
        template:     'tarefaagendada.template',
    },
    status: {
        exibir:   'main.tarefaagendadalog.status',
        visivel:  true,
        tipo:     'enum',
        entidade: 'tarefaagendadalog.status',
        largura: "7rem",
        fixar: true
    },
    tipoexecucao: {
        exibir:   'main.tarefaagendadalog.tipoexecucao',
        visivel:  true,
        tipo:     'enum',
        entidade: 'tarefaagendadalog.tipoexecucao',
        largura: "7rem",
        fixar: true
    },
    datahorainicio: { exibir: 'main.tarefaagendadalog.datahorainicio', visivel: true, tipo: 'date', time: true, largura: '12rem', fixar: true },
    datahorafim:    { exibir: 'main.tarefaagendadalog.datahorafim',    visivel: true, tipo: 'date', time: true, largura: '12rem', fixar: true },
    log:            { exibir: 'main.tarefaagendadalog.log' },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const renderers = {
    tarefaagendada:               { entidade: TarefaAgendada, template: (rowData) => rowData.tarefaagendada?.nome || rowData.tarefaagendada?.id || '' },
    'tarefaagendadalog.status':      TarefaAgendadaLogStatusEnum,
    'tarefaagendadalog.tipoexecucao': TarefaAgendadaLogTipoExecucaoEnum,
};

// ─── Formulário de campos (render prop) ────────────────────────────────────────

// Todos os campos sao preenchidos automaticamente pelo processo agendado que gerou o registro
// (ver TarefaAgendada.executar) - nunca editaveis diretamente pelo admin, essa tela e so um
// historico de execucoes.
class TarefaAgendadaLogFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <div className="grid">
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={{ ...model.tarefaagendada, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={{ ...model.status, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={{ ...model.tipoexecucao, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelCalendar model={{ ...model.datahorainicio, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelCalendar model={{ ...model.datahorafim, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 mt-3">
                    <ModelTextArea model={{ ...model.log, disabled: true }} contexto={contexto} rows={12} />
                </div>
            </div>
        );
    }
}

// ─── Template (componente exportado) ──────────────────────────────────────────

class TarefaAgendadaLogTemplate extends Component {
    render() {
        return (
            <EntityGrid
                entidade={TarefaAgendadaLog}
                model={model}
                identidade="main.tarefaagendadalog"
                permissoes={this.props.permissoes}
                icone="pi-list"
                storageKey="dt-tarefaagendadalogs"
                relacionados={[]}
                renderers={renderers}
                configuracao={this.props.configuracao}
                ordenacaoPadrao={{ sortField: 'datahorainicio', sortOrder: -1 }}
                formulario={(m, ctx) => <TarefaAgendadaLogFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default TarefaAgendadaLogTemplate;
